<template>
  <div class="d-flex align-items-center" @click="goBack()">
    <div class="header-button" >
      <chevron-left-icon size="18" />
    </div>
    <h1 class="page-title link">{{title}}</h1>
  </div>

</template>

<script>

import i18n from '../../i18n'

export default {
  name: 'BackArrow',

  components: {
    i18n
  },

  props: {
    title: {
      type: String,
      default: i18n.t('Back')
    },
    routeBack: {
      type: String,
      default: null
    }
  },
  methods: {
    goBack() {
      if (this.routeBack) {
        this.$router.push({
          name: this.routeBack,
        })
      } else {
        this.$router.go(-1)
      }
    }
  }

}
</script>

<style scoped>
.header-button-line {
  flex-direction: row;
}
.header-button {
  display: inline-block;
  background-color: var(--main-color);
  border-radius: var(--small-border-radius);
  color: var(--main-color-text-color);
  height: 24px;
  width: 24px;
  margin-right: 1em;
}
.header-button svg {
  height: 24px;
  width: 24px;
}
.header-button:hover {
  cursor: pointer;
  background-color: var(--main-color-hover);
  color: var(--main-white);
}
.link:hover{
  cursor: pointer;
  color: var(--main-color-hover);
}
.page-title{
  font-size: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/b122/BackArrow.vue